import { render, staticRenderFns } from "./PendingInvoices.vue?vue&type=template&id=2c729810"
import script from "./PendingInvoices.vue?vue&type=script&lang=js"
export * from "./PendingInvoices.vue?vue&type=script&lang=js"
import style0 from "./PendingInvoices.vue?vue&type=style&index=0&id=2c729810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports